import { atom } from 'jotai';

export const globalFilterRulesExpandedAtom = atom(true);
export const globalFilterAppendedAtomStatusAtom = atom<'dimension' | 'filter'>('dimension');

export const enableFilterAtom = atom(true);
